module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/yN9XM/tc-custom/9781439667835.jpg?1704586003241",
      "alt": "This image is the cover for the book Montanans in the Great War, Military"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Montanans in the Great War, Military\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("World War I continued with fury in the spring of 1918 as American Yanks endeavored to play the key role in stemming the German tide. Montana's Marines suffered the bloodiest day in their history as they became \"Devil Dogs,\" charging through hell on earth at Belleau Wood. Locals in the Wild West Division stormed \"over the top\" into the Argonne Forest, while nurses, \"hello girls,\" Navy Yeomanettes and YMCA workers blazed new gender roles. And young Seaman Mike Mansfield, future legendary senator, served on convoy duty against lurking German U-boats. Award-winning historian Ken Robison illuminates the story of young and vibrant Montanans of all ethnicities as they fought for elusive democracy, at home and abroad, in this world war to end all wars.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Ken Robison\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Native Montanan Ken Robison is historian at the Overholser Historical Research Center and for the Great Falls/Cascade County Historic Preservation Commission and is active in historic preservation throughout central Montana. He is a retired navy captain after a career in naval intelligence. The Montana Historical Society honored Ken as \"Montana Heritage Keeper\" in 2010.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0